"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _outputQueueMaxSamples, _audioPort, _outputQueue, _recycleBuffers;
Object.defineProperty(exports, "__esModule", { value: true });
class AudioPortHandler {
    constructor(audioPort, outputQueue) {
        _outputQueueMaxSamples.set(this, void 0);
        _audioPort.set(this, void 0);
        _outputQueue.set(this, void 0);
        _recycleBuffers.set(this, void 0);
        __classPrivateFieldSet(this, _audioPort, audioPort);
        __classPrivateFieldSet(this, _outputQueue, outputQueue);
        __classPrivateFieldSet(this, _recycleBuffers, []);
        audioPort.onmessage = (event) => {
            const { input0, output0, output1 } = event.data;
            if (input0) {
                // worker sends us back input buffers to avoid unnecessary allocations
                __classPrivateFieldGet(this, _recycleBuffers).push(input0);
            }
            if (output0 && output1) {
                __classPrivateFieldGet(this, _outputQueue).push([output0, output1]);
            }
        };
    }
    process(audio) {
        const msg = {};
        const transferList = [];
        if (audio.input) {
            if (__classPrivateFieldGet(this, _recycleBuffers).length !== 0) {
                const inputCopy = __classPrivateFieldGet(this, _recycleBuffers).pop();
                inputCopy.set(audio.input[0]);
                transferList.push(inputCopy.buffer);
                msg.input0 = inputCopy;
            }
            else {
                msg.input0 = audio.input[0];
            }
        }
        if (audio.output) {
            const toRecycle = __classPrivateFieldGet(this, _outputQueue).pull(audio.output);
            // request audio - send back channel arrays transferring underlying
            // buffers if possible
            if (toRecycle) {
                [msg.output0, msg.output1] = toRecycle;
                transferList.push(...toRecycle.map((array) => array.buffer));
            }
            else {
                msg.output0 = audio.output[0];
                msg.output1 = audio.output[1];
            }
        }
        __classPrivateFieldGet(this, _audioPort).postMessage(msg, transferList);
    }
    close() {
        __classPrivateFieldGet(this, _audioPort).close();
        __classPrivateFieldGet(this, _outputQueue).clear();
    }
}
exports.default = AudioPortHandler;
_outputQueueMaxSamples = new WeakMap(), _audioPort = new WeakMap(), _outputQueue = new WeakMap(), _recycleBuffers = new WeakMap();
